const PERSONAS = [
  {
    title: 'Polypharmacy patients',
    desc: 'Managing 3 or more medications across conditions.',
  },
  {
    title: 'Caregivers',
    desc: "Coordinating a parent or partner\u2019s regimen.",
  },
  {
    title: 'Safety-conscious consumers',
    desc: 'Mixing prescriptions with OTC and supplements.',
  },
];

export default function PersonaCards() {
  return (
    <section className="py-16 md:py-20" style={{ backgroundColor: '#FFFFFF' }} data-testid="landing-personas">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-12" style={{ color: '#5B2D1F' }}>
          Built for everyone managing medications
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {PERSONAS.map((p, i) => (
            <div
              key={p.title}
              className="rounded-2xl border p-6 text-center"
              style={{ backgroundColor: '#FBF6EF', borderColor: '#D7E2E8' }}
              data-testid={`landing-persona-${i}`}
            >
              <div className="w-16 h-16 mx-auto rounded-full mb-4 overflow-hidden" style={{ backgroundColor: '#E8F4F4' }}>
                <img src="/brand/logo-round.png" alt="" className="w-full h-full opacity-35" />
              </div>
              <h3 className="text-lg font-extrabold mb-1" style={{ color: '#5B2D1F' }}>{p.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: '#6B4A3A' }}>{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
